import axios from 'axios'
import {FUNCTIONS_URL} from '../../config'
import {auth} from '../../Auth'

export default async function restoreForm(formId, archiveId) {
  const token = await auth.getToken()
  const headers = {'Content-Type': 'application/json'}
  if (token) headers['Authorization'] = `Bearer ${token}`
  const response = await axios.get(`${FUNCTIONS_URL}/utilities/restoreForm`, {
    params: {formId, archiveId},
    headers,
  })
  if (response?.data) return response.data
  throw new Error('restoreForm returned no data')
}
